import { AD_TYPE } from '@seek/je-shared-data';
import { upgraded } from '@src/job';
import { stepConfig } from './stepConfig';

export type GetStepsParams = {
  createdJobId?: string | null;
  isUpgradeable: boolean;
  hasJobUpgraded: boolean;
  selectedAdType?: AD_TYPE;
};

export const getSteps = (params: GetStepsParams) => {
  const { isUpgradeable, createdJobId, selectedAdType, hasJobUpgraded } =
    params;

  const {
    postJobSuccess,
    enhanceJob,
    payment,
    jobSummaryAndDesc,
    title,
    basicDetails,
    editTitle,
    editBasicDetails
  } = stepConfig(createdJobId, selectedAdType);

  const postJobSteps = [title, basicDetails];
  const editJobSteps = [editTitle, editBasicDetails];

  const showPayment =
    isUpgradeable && upgraded(selectedAdType) && !hasJobUpgraded;

  return [
    ...(createdJobId ? editJobSteps : postJobSteps),
    ...(isUpgradeable ? [enhanceJob] : []),
    ...(showPayment ? [payment] : []),
    jobSummaryAndDesc,
    postJobSuccess
  ];
};
